// Import components
import './Admindashboard.css';
import React, { useMemo, useState,useEffect } from "react";
import Breadcrumbs from '../../../Components/Common/Breadcrumb';
import TableContainer from '../../../Components/Common/TableContainer';
import { Modal, ModalHeader, Card, CardBody, Row, Col, Input,Alert } from 'reactstrap';
import axios from "axios";

interface Column {
    header: string;
    accessorKey?: string;
    accessorFn?: (row: any) => string;
    enableColumnFilter: boolean;
    enableSorting: boolean;
    cell?: (info: any) => React.ReactNode;
}

const CategoryManagement = () => {


    // const [modal_standard_delete_pack, setmodal_delete_pack] = useState(false);

    // function deletePack() {
    //     setmodal_delete_pack(!modal_standard_delete_pack);
    //     removeBodyCss();
    // }
    // function removeBodyCss() {
    //     document.body.classList.add("no_padding");
    // }

    const [alertMsgg, setAlertMsgg] = useState<any>({open:false, type:"success", content:'Messages here.', time:'4000'});
    const handleAlertMsggClose = ( event?: React.SyntheticEvent | Event, reason?: string) => {  
        if (reason === "clickaway") { return; } 
        setAlertMsgg({ ...alertMsgg, open: false }) 
    };
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showloader, setshowloader] = useState(true);
    



        
    const columns: Column[] = useMemo(() => [
        {
            header: 'ID',
            accessorFn: (row) => row.id.toString(),
            enableColumnFilter: false,
            enableSorting: false,
            cell: ({ row }) => row.index + 1,
        },
        {
            header: 'Name',
            accessorFn: (row) => row.name,
            enableColumnFilter: false,
            enableSorting: true,
            cell: ({ row }) => (
                <p className="mb-0 fw-medium">
                    {row.original.name}
                </p>
            ),
        },
        {
            header: 'Price',
            accessorFn: (row) => row.price,
            enableColumnFilter: false,
            enableSorting: true,
            cell: ({ row }) => (
                <span>${row.original.price}</span>
            ),
        },
        {
            header: 'Features',
            accessorFn: (row) => row.features,
            enableColumnFilter: false,
            enableSorting: false,
            cell: ({ row }) => (
                <span>
                {row.original.features?.map((f: any) => f.feature).join(', ')}
                </span>
            ),
        },
        {
            header: 'Description',
            accessorFn: (row) => row.description,
            enableColumnFilter: false,
            enableSorting: false,
            cell:({row}) => (
                <span>{row.original.description}</span>
            )
        },

        {
        header: 'Action',
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row , table}) => {
            const index = row.index;
            const visibleRows = table.getRowModel().rows; // All visible rows
            const isLastRow = index === visibleRows.length - 1;
            const isFirstRow = index === 0;

            return (
                <div className="d-flex gap-2 flex-wrap">
                    <button
                    className="btn btn-dark btn-sm d-flex align-items-center"
                    onClick={() => handleEditPack(row.original)}
                    >
                    <i className="bx bxs-pencil me-1"></i>
                    Edit
                    </button>

                    {row.original.can_delete && (
                    <button
                        className="btn btn-sm btn-danger d-flex align-items-center"
                        onClick={() => handleDeleteClick(row.original.id)}
                    >
                        <i className="bx bxs-trash-alt me-1"></i>
                        Delete
                    </button>
                    )}

                {/* Move Up Button */}
                <button
                    className="btn btn-dark btn-sm d-flex align-items-center"
                    disabled={isFirstRow}
                    onClick={() =>
                    move_plt_package(
                        row.original.id,
                        visibleRows[index - 1]?.original.id,
                        true
                    )
                    }
                >
                    <i className="bx bx-chevrons-up me-1"></i>Move Up
                </button>

                {/* Move Down Button */}
                <button
                    className="btn btn-dark btn-sm d-flex align-items-center"
                    disabled={isLastRow}
                    onClick={() =>
                    move_plt_package(
                        row.original.id,
                        visibleRows[index + 1]?.original.id,
                        false
                    )
                    }
                >
                    <i className="bx bx-chevrons-down me-1"></i> Move Down
                </button>
                </div>
            );
        }
        }


    ], []);



    const [selectedPack, setSelectedPack] = useState<any>(null);

    const handleAddPack = () => {
        setSelectedPack({
            name: '',
            price: '',
            trial_days:'',
            features: [],
            description: '',
        });
        // setErrors({ firstname: '', lastname: '', email: '', phone: '', selectedDomains: '' });
        setErrors({ name: '', price: '', features: '', description: '', trial_days: ''});
        setIsModalOpen(true);
        
    };

    const handleEditPack = (pack: any) => {
        setSelectedPack(pack);
        setErrors({ name: '', price: '', features: '', description: '', trial_days: ''}); 
        setIsModalOpen(true);
    };
    


    const [platPacks, setPlatPacks] = useState([{name:'', id:1}]);
    // const [platPacks, setPlatPacks] = useState<any[]>([]);


    
    const fetchexps = async () => {    
        try{
        setshowloader(true)
        const response = await axios.get(`/accounts/get_platpacks`,{ withCredentials: true ,headers: {
            'Content-Type': 'application/json',
        },});
        if (response.status === "SENT"){
            setshowloader(false)
            const fetchedpacks = response.packs.map((item:any,index: number)=>({
                id                  : item.id,
                name                : item.name,
                price               : item.price,
                ptype               : item.ptype,
                trial_days          : item.trial_days,
                features            : item.features,
                description         : item.description,
                can_delete          : item.initiated,
            }));
            console.log('yshs adata aaya ya nahi iska ye bta ',fetchedpacks)
            setPlatPacks(fetchedpacks);
        }
    }catch (error:any) {
        if (error.response) {
            if ([401, 422].includes(error.response.status)) {
            console.log('Error in stripe payment')
            setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
            }
            else if (error.response.status === 403) {
            console.log('Error stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                setTimeout(()=>{window.location.href="/logout"}, 2000)
            } else {
            console.log('An error occurred')
            setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
            }
        } else {
        console.log('An error occurred')
        setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
        }
        setshowloader(false)
    }
    };

    useEffect(() => {
        fetchexps();
    }, [])
    
    useEffect(() => {
        if (alertMsgg.open) {
            const timer = setTimeout(() => {
                setAlertMsgg((prev: any) => ({ ...prev, open: false }));
            }, parseInt(alertMsgg.time || '3500'));

            return () => clearTimeout(timer);
        }
    }, [alertMsgg.open]);

     const [errors, setErrors] = useState({
        name: '',
        price: '',
        features: '',
        trial_days:'',
        description: ''
    });


    const move_plt_package = async (cid:any=null, ocid:any=null, moveup:any=false, a:any=null) => {
        console.log("aaaaaaaaaa", a)
        try{
            setshowloader(true);
            const formData = new FormData();
            formData.append('cid', cid);
            formData.append('ocid', ocid);
        
            formData.append('moveup', moveup);

            const response = await axios.post(`accounts/handlepltpackage`, formData, { withCredentials: true, headers: { 'Content-Type': 'multipart/form-data' } });
        
            console.log('response_ move__subdomain_content___ ', response)
            if (response.status === "DONE") {
                // window.location.reload()
                setshowloader(false);
                fetchexps();
            }
        } catch (error:any) {
            if (error.response) {
                if ([401, 422].includes(error.response.status)) { setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" }); } 
                else if (error.response.status === 403) {
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(()=>{window.location.href="/login"}, 2000)
                } else { setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" }); }
            } else { setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" }); }
            setshowloader(false);
        }  
    }





    const handleSavePack = async () => {
        const newErrors: any = {};

        if (!selectedPack.name) newErrors.name = 'Package name is required';
        if (!selectedPack.price) newErrors.price = 'Package price is required';
        // if (!selectedPack.trial_days) newErrors.trial_days = 'Package trial days is required';
        if (!selectedPack.features || selectedPack.features.length === 0) newErrors.features = 'Package feature is required';
        if (!selectedPack.description) newErrors.description = 'Description is required';

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        // setErrors();
        if (!selectedPack.name || !selectedPack.price || !selectedPack.features || !selectedPack.description|| selectedPack.features.length === 0)  {
            setAlertMsgg({ ...alertMsgg, open: true, content: "Please fill all the fields.", type: "error" });
            setTimeout(() => {
                setAlertMsgg({ ...alertMsgg, open: false, content: "", type: "" });
            }, 2000);
            return;
        }
        let featuresFormatted = '';
            if (Array.isArray(selectedPack.features)) {
                featuresFormatted = selectedPack.features.map((f: any) => f.feature).join(',');
            } else if (typeof selectedPack.features === 'string') {
                featuresFormatted = selectedPack.features;
            }
    
        let data = new FormData();
        data.append('pid', selectedPack.id ? selectedPack.id : '');
        data.append('name', selectedPack.name);
        data.append('price', selectedPack.price);
        data.append('trial_days', selectedPack.trial_days);
        // data.append('features', selectedPack.features.map((f: any) => f.feature).join(','));
        data.append('features', featuresFormatted);
        data.append('description', selectedPack.description);
    
        // const openloader = document.querySelector('.loaderWeb') as HTMLElement | null;
        //     if (openloader) openloader.style.display = 'flex';
    
        try {
            setshowloader(true)
            const response = await axios.post(`/accounts/updatepltpack`, data, {
                // headers: { "Content-Type": "multipart/form-data" },
                withCredentials: true,
            });
    
            if (response.status === "DONE") {
                fetchexps();
                setshowloader(false)
                setIsModalOpen(false);
                setSelectedPack(null);
                setAlertMsgg({ ...alertMsgg, open: true, content: selectedPack.id ? "Package updated successfully!" : "Package created successfully!", type: "success" });
        
            }
            if (selectedPack.id) {
                const updatedPacks = platPacks.map((row: any) =>
                    row.id === selectedPack.id ? selectedPack : row
                );
                setPlatPacks(updatedPacks);
            } else {
                selectedPack.can_delete = true;
                const mynewpack = {
                    ...selectedPack,
                    id: platPacks.length + 1  
                };
                const updatedPacks = [...platPacks, mynewpack];
                setPlatPacks(updatedPacks);
            }

            if (response.status === "INERROR") {
                setshowloader(false)
                setIsModalOpen(false);
                // setSelectedPack(null);
                setAlertMsgg({ ...alertMsgg, open: true, content: "Packages Name already exist!", type: "error" });
                setTimeout(() => {
                    setAlertMsgg({ ...alertMsgg, open: false, content: "", type: "" });
                }, 4000);
            }
            
        }catch (error:any) {
            if (error.response) {
                if ([401, 422].includes(error.response.status)) {
                console.log('Error in stripe payment')
                setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
                }
                else if (error.response.status === 403) {
                console.log('Error stripe payment')
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(()=>{window.location.href="/logout"}, 2000)
                } else {
                console.log('An error occurred')
                setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                }
            } else {
            console.log('An error occurred')
            setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            }
            setshowloader(false)
            // const closeloader = document.querySelector('.loaderWeb') as HTMLElement | null;
            // if (closeloader) closeloader.style.display = 'none';
        }
    };



    
    const [deleteId, setDeleteId] = useState<number | null>(null);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

    
    const handleDeleteClick = (id: number) => { setDeleteId(id); setDeleteDialogOpen(true); }; // Open Delete Conf. Dialog
    const handleConfirmDelete = async () => { // Handle delete 

    // const openloader = document.querySelector('.loaderWeb') as HTMLElement | null;
    // if (openloader) {openloader.style.display = 'flex';}

    try { 
        setshowloader(true)
        const response = await axios.post(`/accounts/updatepltpack`, {pid:deleteId, to_delete:true}, { headers: { "Content-Type": "multipart/form-data" }, withCredentials: true });
        if (response.status === "DELETED"){
            fetchexps();
            setshowloader(false)
            setAlertMsgg({ ...alertMsgg, open: true, content:"Package deleted!", type:"success" })
            // const closeloader = document.querySelector('.loaderWeb') as HTMLElement | null;
            // if (closeloader) {closeloader.style.display = 'none';}  
        }
        if (deleteId !== null) { setPlatPacks(platPacks.filter((pack) => pack.id !== deleteId)); }
        setDeleteDialogOpen(false); setDeleteId(null);
        } 
        catch (error:any) {
            if (error.response) {
                if ([401, 422].includes(error.response.status)) {
                setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
                }
                else if (error.response.status === 403) {
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(()=>{window.location.href="/logout"}, 2000)
                } else {
                console.log('An error occurred')
                setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                }
            } else {
            console.log('An error occurred')
            setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
        }
        setTimeout(() => {
                    setAlertMsgg({ ...alertMsgg, open: false, content: "", type: "" });
                }, 2000);
        setshowloader(false)
    }
    };
    const handleCancelDelete = () => { setDeleteDialogOpen(false); setDeleteId(null); }; // Cancel Delete


    


    document.title = "Platform Packages | BizServe";


    // const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, field: string) => {
    //     const value = e.target.value;
    //     console.log('value-----',value)
    //     setSelectedPack((prev) => ({
    //     ...prev,
    //     [field]: field === 'features' ? value.split(',').map((feature: string) => ({ feature })) : value,
    //     }));
    // };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, field: string) => {
    const value = e.target.value;
    setSelectedPack((prev) => ({...prev,
        [field]:field === 'features' ? value.split(',').map((feature: string) => feature.trim())
                      .filter((feature: string) => feature !== '') // remove empty features
                      .map((feature: string) => ({ feature })) : value,
            }));
        };


    return (
        <div className="page-content">
            <div className="container-fluid">
                <Breadcrumbs title="Subscription" breadcrumbItem="Subscription packages" />
                {alertMsgg.open && (
                    <Alert 
                        color={alertMsgg.type === "success" ? "success" : "danger"} 
                        toggle={handleAlertMsggClose}
                        style={{ fontWeight: "bold" }}
                    >
                        {alertMsgg.content}
                    </Alert>
                )}
                <div className="loaderContainer" hidden={!showloader}>
                    <div className="spinner">
                    <div></div>  
                    <div></div>    
                    <div></div>    
                    <div></div>    
                    <div></div>    
                    <div></div>    
                    <div></div>    
                    <div></div>    
                    <div></div>    
                    <div></div>    
                </div>
            </div>
                <Row>
                    <Col md={12}>
                        <div className="d-flex justify-content-end align-items-start gap-2">
                            <button className="btn btn-primary mb-3" onClick={handleAddPack}>+ Add Package</button>
                        </div>
                    </Col>
                    <Col md={12}>
                        <Card className="rounded-4 border">
                            <CardBody>
                                <TableContainer
                                    columns={columns}
                                    data={platPacks}
                                    isGlobalFilter={true}
                                    isPagination={true}
                                    SearchPlaceholder="Search By Name..."
                                    pagination="pagination"
                                    paginationWrapper='dataTables_paginate paging_simple_numbers'
                                    tableClass="table-bordered dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Modal
                    isOpen={isModalOpen}
                    // toggle={addPack}
                    toggle={() => setIsModalOpen(false)}
                    centered
                    className="rounded-4"
                >
                <div className="modal-header border-0 pb-0">
                    <h5 className="modal-title">
                        {selectedPack?.id ? 'Edit Package' : 'Add Package'}
                    </h5>
                    <button type="button" className="btn-close" onClick={() => setIsModalOpen(false)}></button>
                </div>
                    <div className="modal-body p-4">
                        <Row>
                            <Col lg={12}>
                                <div className="mb-3">
                                    <label className="form-label">Package Name<span className="text-danger px-1">*</span></label>
                                    {/* <input
                                        className="form-control"
                                        type="text"
                                        placeholder="Package Name"
                                        value={selectedPack?.name || ''}
                                        onChange={(e) => handleInputChange(e, 'name')}
                                    /> */}
                                    <input
                                        className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                        type="text"
                                        placeholder="Package Name"
                                        value={selectedPack?.name || ''}
                                        onChange={(e) => {
                                            handleInputChange(e, 'name');
                                            setErrors((prev) => ({ ...prev, name: '' })); // clear error on typing
                                        }}
                                    />
                                    {errors.name && <div className="invalid-feedback">{errors.name}</div>}

                                </div>
                            </Col>
                            <Col lg={12}>
                                <div className="mb-3">
                                    <label className="form-label">Package Price<span className="text-danger px-1">*</span></label>
                                    {/* <input
                                        className="form-control"
                                        type="number"
                                        placeholder="Package Price"
                                        value={selectedPack?.price || ''}
                                        onChange={(e) => handleInputChange(e, 'price')}
                                    /> */}
                                    <input
                                        className={`form-control ${errors.price ? 'is-invalid' : ''}`}
                                        type="number"
                                        placeholder="Package Price"
                                        value={selectedPack?.price || ''}
                                        onChange={(e) => {
                                            handleInputChange(e, 'price');
                                            setErrors((prev) => ({ ...prev, price: '' }));
                                        }}
                                    />
                                    {errors.price && <div className="invalid-feedback">{errors.price}</div>}
                                </div>
                            </Col>
                            <Col lg={12}>
                                <div className="mb-3">
                                    <label className="form-label">Trial Days</label>
                                    {/* <input
                                        className="form-control"
                                        type="number"
                                        placeholder="Package Price"
                                        value={selectedPack?.price || ''}
                                        onChange={(e) => handleInputChange(e, 'price')}
                                    /> */}
                                    <input
                                        className={`form-control ${errors.trial_days ? 'is-invalid' : ''}`}
                                        type="number"
                                        placeholder="Package Trial Days"
                                        value={selectedPack?.trial_days || ''}
                                        onChange={(e) => {
                                            handleInputChange(e, 'trial_days');
                                            setErrors((prev) => ({ ...prev, trial_days: '' }));
                                        }}
                                    />
                                    {errors.trial_days && <div className="invalid-feedback">{errors.trial_days}</div>}
                                </div>
                            </Col>
                            <Col lg={12}>
                                <div className="mb-3">
                                    <label className="form-label">Features<span className="text-danger px-1">*</span></label>
                                    <Input
                                        name="features"
                                        tag="textarea"
                                        rows={5}
                                        placeholder="Package Features"
                                        className={errors.features ? 'is-invalid' : ''}
                                        value={
                                            selectedPack?.features
                                                ? selectedPack.features.map((f: any) => f.feature).join(',')
                                                : ''
                                        }
                                        onChange={(e) => {
                                            handleInputChange(e, 'features');
                                            setErrors((prev) => ({ ...prev, features: '' }));
                                        }}
                                    />
                                    {errors.features && <div className="invalid-feedback">{errors.features}</div>}
                                </div>
                            </Col>

                            <Col lg={12}>
                                <div className="mb-3">
                                    <label className="form-label">Description<span className="text-danger px-1">*</span></label>
                                    <input
                                        className={`form-control ${errors.description ? 'is-invalid' : ''}`}
                                        type="text"
                                        placeholder="Package Description"
                                        value={selectedPack?.description || ''}
                                        onChange={(e) => {
                                            handleInputChange(e, 'description');
                                            setErrors((prev) => ({ ...prev, description: '' }));
                                        }}
                                    />
                                    {errors.description && <div className="invalid-feedback">{errors.description}</div>}
                                </div>
                            </Col>

                        </Row>
                    </div>
                    <div className="modal-footer">
                        <button className="btn btn-primary" onClick={handleSavePack}>Save Package</button>
                    </div>
                </Modal>
                <Modal
                    isOpen={deleteDialogOpen}
                    toggle={handleCancelDelete}
                    centered
                    className="rounded-4"
                >
                    <ModalHeader className="py-3 px-4" onClick={handleCancelDelete}>
                        <div className="modal-title mt-0 font-size-16 text-dark">
                        Delete Package
                        </div>
                    </ModalHeader>

                    <div className="modal-body">
                        <p>Are you sure you want to delete this package?</p>
                    </div>

                    <div className="modal-footer">
                        <button 
                        type="button" 
                        className="btn btn-sm btn-soft-dark" 
                        onClick={handleCancelDelete}
                        >
                        Cancel
                        </button>
                        <button 
                        type="button" 
                        className="btn btn-sm btn-danger"
                        onClick={handleConfirmDelete}
                        >
                        Delete
                        </button>
                    </div>

                </Modal>

                
            </div>
        </div>
    );
};

export default CategoryManagement;
